export default "__VITE_ASSET__BuKDPKCm__"